export const usePageTitle = (): void => {
  const { titleSuffix } = useAppConfig();

  useHead({
    titleTemplate: (titleChunk) => {
      return titleChunk ? `${titleChunk} | ${titleSuffix}` : titleSuffix;
    },
  });
};
